"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAsJson = void 0;
/* istanbul ignore file -- ESM only */

/* eslint-disable import/extensions -- ESM only */

/* eslint-disable @typescript-eslint/no-unsafe-assignment -- ESM only */

/* eslint-disable @typescript-eslint/no-require-imports -- ESM only */

const {
  createParser: createParserFromFile
} = require('../nuqs-wrapper');
const parser = createParserFromFile;
const parseAsJson = runtimeParser => parser({
  parse: query => {
    try {
      const obj = JSON.parse(decodeURIComponent(query));
      return runtimeParser(obj);
    } catch {
      return null;
    }
  },
  serialize: value => JSON.stringify(value),
  eq(a, b) {
    return a === b || JSON.stringify(a) === JSON.stringify(b);
  }
});
exports.parseAsJson = parseAsJson;
